import React from 'react';

const ProductGroupContext = React.createContext();

export default ProductGroupContext;
